import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'
import {MainLayout, LoggedOutMain, LoggedOutHeaderLogo, LogoutLayout } from './style'
import Shop from '../shop-pages'
import Home from '../Home'
import SuccessPage from '../Home/SuccessPage'
import OpenPosts from '../open-posts'
import PostDetails from '../open-posts/PostDetails'
import StripeCheckout from '../shop-pages/checkout'
import PackageDetails from '../shop-pages/PackageDetails'
import PrivacyPolicy from '../static/PrivacyPolicy'
import TermsOfService from '../static/TermsOfService'
import Disclaimer from '../static/Disclaimer'
import RefundPolicy from '../static/RefundPolicy'
import PortFolioManager from '../PortFolioManager'
import { Layout, Button} from 'antd'
import metadata from '../../metadata.json'
import moment from "moment";
const { Footer } = Layout;
const LoggedOutHeader = ({onLogin}) => {

  return (
    <MainLayout>
      <LogoutLayout>
        <LoggedOutMain>
          <Link to='/'>
            <LoggedOutHeaderLogo>
              <div>OptionsEDU</div>
            </LoggedOutHeaderLogo>
          </Link>
          <Link to='/'/>
          <div className="right-login">
            <Button onClick={onLogin}>Login</Button>
          </div>
        </LoggedOutMain>
        <Switch>
          <Route path='/shop/tradeportfoliomanager' component={PortFolioManager}/>
          <Route path='/shop/:packageId' component={PackageDetails} />
          <Route path='/checkout' component={StripeCheckout} />
          <Route path='/shop' component={Shop}/>
          <Route path='/tradeportfoliomanager' component={PortFolioManager}/>
          <Route path='/posts' component={OpenPosts}/>
          <Route path='/post-detail/:id' component={PostDetails}/>
          <Route path='/privacypolicy' component={PrivacyPolicy}/>
          <Route path='/termsofservice' component={TermsOfService}/>
          <Route path='/refundpolicy' component={RefundPolicy}/>
          <Route path='/disclaimer' component={Disclaimer}/>
          <Route path='/welcome' component={SuccessPage}/>
          <Route path='/' component={ (props) => <Home onLogin={onLogin} {...props} />}/>
        </Switch>
          <Footer className="footer">
              <div>OptionsEDU, LLC ©{moment().format('YYYY')} | Version : {metadata.version} <br />
                <Link to="/privacypolicy">Privacy Policy </Link> |
                <Link to="/termsofservice"> Terms of Service </Link> |
                <Link to="/refundpolicy"> Refund Policy </Link> |
                <Link to="/disclaimer"> Disclaimer </Link>
              </div>
          </Footer>
      </LogoutLayout>
    </MainLayout>
  )
}

export default LoggedOutHeader


// WEBPACK FOOTER //
// ./src/components/layout-main/loggedOutHeader.js